import { WHATSAPP_URL, WhatsAppIcon } from "./shared";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform duration-200 hover:scale-105 md:bottom-7 md:right-7"
      data-testid="whatsapp-floating-button"
    >
      <WhatsAppIcon className="h-7 w-7" />
    </a>
  );
}
